import { useEffect, useState } from "react";
import { Button, FormControl } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../app/hooks";
import { createWagerAsync, getWagersAsync } from "../bettingSlice";
import WagerCreationModal from "../components/WagerCreationModal";
import WagerList from "../components/WagerList";
import { WagerCreation } from "../types";

export default function Wagers() {
  const dispatch = useDispatch();
  const [wagerQuery, setWagerQuery] = useState("");
  const [creatingWager, setCreatingWager] = useState(false);

  var wagers = useAppSelector((state) => state.betting.wagers);

  useEffect(() => {
    dispatch(getWagersAsync(`title=${wagerQuery}&resolved=false`));
  }, [wagerQuery]);

  const createWager = (wager: WagerCreation) => {
    dispatch(createWagerAsync(wager));
    setCreatingWager(false);
  };

  return (
    <>
      <h2>Wagers</h2>
      <Button
        onClick={() => setCreatingWager(true)}
        variant="secondary"
        className="mb-3 mt-3"
      >
        Create Wager
      </Button>
      <FormControl
        value={wagerQuery}
        onChange={(e) => setWagerQuery(e.target.value)}
        placeholder="Search for wager by title"
      />
      <WagerList wagers={wagers} />
      <WagerCreationModal
        onClose={() => setCreatingWager(false)}
        show={creatingWager}
        onSubmit={(wager) => createWager(wager)}
      />
    </>
  );
}
